import { Permiso } from "./Enums/permiso.enum";

export class User {
    id: any
    user : UserInfo;
    token: string;
    refreshToken?: string;
    permisos: any[];
    imagenPerfil?: string | null;
    newImage: any;
    validPassword: any;
}

export class rol {
    id: string;
    nombre: string;
    estatus: number;
    /** 4 Cliente, 5 Cadena, 6 Sucursal, 7 Caja. Si es null, se usa idRol. */
    jerarquiaOperativa?: number | string | null;
}

export class UserInfo {
    id: any;
    validPassword: any
    rol: rol;
    userName: string;
    emailConfirmed: string;
    password: string;
    telefono: any;
    cadena?: any;
    estatus?: boolean;
    nombre: string;
    username: any;
    apellidoPaterno?: string;
    apellidoMaterno?: string;
    nombreCompleto?: string;
    permisos: any[];
    email:string;
    cliente: any;
    sucursal?: any;
    idCliente?:number;
    idSucursal:number;
    idCadena?:number;
    imagenPerfil: string;
    idCaja: number;
    idRol: any;
    caja: any;
}